export const auth = {
  activationPage: {
    loading: 'Account activeren…',
  },
  footer: {
    social: {
      facebook: {
        ariaLabel: 'Facebook',
        link: 'https://www.facebook.com/creativeshelter/',
      },
      instagram: {
        ariaLabel: 'Instagram',
        link: 'https://www.instagram.com/creativeshelter/',
      },
      linkedIn: {
        ariaLabel: 'LinkedIn',
        link: 'https://be.linkedin.com/company/creative-shelter/',
      },
      website: {
        ariaLabel: 'Website Creative Shelter',
        link: 'https://www.creativeshelter.be/',
      },
    },
    trademark: 'Creative Shelter © {{year}}',
  },
  forgotPasswordPage: {
    form: {
      submitButton: 'Stuur de link',
    },
    header: {
      subtitle: 'Vul je e-mailadres in en wij bezorgen je de nodige stappen om een nieuw wachtwoord in te stellen.',
      title: 'Wachtwoord opnieuw instellen',
    },
    loginCta: {
      link: 'Aanmelden',
      text: 'Weet je je wachtwoord nog?',
    },
    successAlert: {
      description:
        'De stappen om je nieuwe wachtwoord in te stellen zitten in je mailbox. Niets ontvangen? Dubbelcheck je e-mailadres even.',
      title: 'De stappen zitten in je mailbox!',
    },
    tokenExpiredAlert: {
      description: 'Vraag hier een nieuwe link aan om je wachtwoord te wijzigen.',
      title: 'Link verlopen',
    },
  },
  loginPage: {
    accountantLoginCta: {
      action: '<accountantLink href="https://api.creativeshelter.be/accountants/login">Meld je hier aan</accountantLink>',
      message: 'Ben je een boekhouder?',
    },
    errors: {
      ineligible: {
        description:
          'Je kan je nog niet aanmelden, omdat je niet automatisch in aanmerking komt. Je profiel en activiteiten dubbelchecken we even, je hoort snel meer van ons!',
        title: 'Wachten op goedkeuring',
      },
      invalidEmailOrPassword: 'Je e-mailadres of wachtwoord is niet juist.',
      rejected: {
        description:
          'We hebben je profiel gecontroleerd en je komt niet in aanmerking om te factureren via Creative Shelter. Daarom is je account jammer genoeg gedeactiveerd.',
        title: 'Sorry, je komt niet in aanmerking',
      },
      unverifiedEmail: {
        description: 'Je e-mailadres is nog niet geverifieerd. Controleer je mailbox en bevestig je e-mailadres.',
        title: 'Wachten op verificatie',
      },
    },
    forgotPasswordLink: 'Wachtwoord vergeten?',
    form: {
      emailField: {
        label: 'E-mailadres',
      },
      passwordField: {
        label: 'Wachtwoord',
      },
      submitButton: 'Aanmelden',
    },
    header: {
      eyebrow: 'Aanmelden',
      subtitle: 'Meld je aan om verder te gaan naar het platform.',
      title: 'Welkom terug!',
    },
    registerCta: {
      action: 'Maak een account aan',
      message: 'Heb je nog geen account?',
    },
    sessionExpiredAlert: {
      description: 'Meld je opnieuw aan om verder te gaan.',
      title: 'Sessie verlopen',
    },
  },
  logo: 'Website Creative Shelter',
  passwordResetErrors: {
    ineligible: {
      description:
        'Je profiel is nog niet goedgekeurd en daarom kan je nog geen nieuw wachtwoord kiezen. Zodra je profiel is gecheckt, laten we je iets weten.',
      title: 'Wachten op goedkeuring',
    },
    rejected: {
      description:
        'We hebben je profiel gecheckt, maar je komt niet in aanmerking om te factureren via Creative Shelter. Je account is om die reden gedeactiveerd.',
      title: 'Sorry, je komt niet in aanmerking',
    },
    unverifiedEmail: {
      description:
        'Je kan geen nieuw wachtwoord aanvragen zolang je e-mailadres niet geverifieerd is. Check even je mailbox en verifieer je e-mailadres.',
      title: 'Wachten op verificatie',
    },
  },
  registrationPage: {
    common: {
      header: {
        pill: 'Registratie',
      },
      loginCta: {
        action: 'Aanmelden',
        message: 'Heb je al een account?',
      },
      previousStepButton: 'Vorige',
      referralCode: {
        addButton: 'Kortingscode',
        applied: 'Korting!',
        form: {
          invitationsField: {
            description:
              'We zien dat verschillende freelancers je uitgenodigd hebben. Kies welke uitnodiging je wilt accepteren, of vul zelf een (andere) kortingscode in.',
            invitedAt: 'Uitgenodigd op {{date}}',
          },
          referralCodeField: {
            errors: {
              expired: 'Deze kortingscode is verlopen.',
              generic: 'De kortingscode kan momenteel niet gevalideerd worden.',
              invalid: 'Deze kortingscode is niet geldig.',
            },
            invitationDescription: 'Je bent uitgenodigd door {{name}} met kortingscode <code>{{code}}</code>.',
            label: 'Kortingscode',
          },
          submitButton: 'Toepassen',
        },
        types: {
          fromAccountant: 'De kortingscode {{referralCode}} van boekhouder {{name}} is toegepast!',
          fromAdmin: {
            generic: 'De kortingscode {{referralCode}} is toegepast!',
          },
          fromUser: 'Korting dankzij de code {{referralCode}} van {{name}}! Maak je eerste factuur aan en geniet beide van een korting!',
        },
      },
    },
    stepAccountInformation: {
      alertNoElibibleNacebelCodes: {
        description:
          'Je kan verdergaan met je registratie, maar je account activeren we nadat we een manuele controle deden van je activiteiten.',
        title: 'Je komt niet standaard in aanmerking',
      },
      form: {
        callingCodeField: {
          label: 'Landcode',
          options: {
            other: 'Andere',
          },
        },
        emailField: {
          errors: {
            exists: 'Dit e-mailadres is al in gebruik. Meld je aan of stel je wachtwoord opnieuw in.',
            generic:
              'Er ging iets mis bij het valideren van je e-mailadres. Neem contact op met <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het probleem zich blijft voordoen.',
          },
          label: 'E-mailadres',
        },
        passwordField: {
          label: 'Wachtwoord',
          requirements: {
            error: 'Het wachtwoord voldoet niet aan de vereisten.',
            minLength: 'Minstens 8 tekens',
            mixedCasing: 'Minstens 1 hoofdletter en 1 kleine letter',
            nonAlpha: 'Minstens 1 cijfer of speciaal teken',
          },
        },
        phoneNumberField: {
          label: 'Telefoonnummer',
        },
        submitButton: 'Volgende',
      },
      header: {
        subtitle: 'Klaar om erin te vliegen?',
        title: 'Hi {{name}}',
      },
    },
    stepBusinessInformation: {
      errors: {
        fallback: 'Er is een onverwachte fout opgetreden tijdens je registratie.',
        httpError:
          'Er ging iets mis bij het registreren. Neem contact op met <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het probleem zich blijft voordoen.',
      },
      form: {
        mainOccupationField: {
          label: 'Statuut',
          options: {
            mainOccupation: 'Hoofdberoep',
            secondaryOccupation: 'Bijberoep',
          },
        },
        otherActivitiesField: {
          label: 'Beschrijf je extra creatieve activiteiten',
        },
        primaryActivityField: {
          label: 'Hoofdactiviteit',
        },
        secondaryActivityField: {
          label: 'Heb je nog andere creatieve activiteiten?',
        },
        submitButton: 'Maak een account aan',
      },
      header: {
        subtitle: 'Vertel ons meer over je eenmanszaak.',
        title: 'Hi {{name}}',
      },
    },
    stepCompany: {
      alert: {
        description:
          'Ons platform is gemaakt voor eenmanszaken. Gelukkig biedt Creative Shelter ook een oplossing voor vennootschappen. <break/>Interesse? <kiiaLink href="https://www.creativeshelter.be/kom-ik-in-aanmerking">Check of je in aanmerking komt</kiiaLink>, dan pikken we het snel met je op.',
        title: 'Creative Shelter voor vennootschappen',
      },
      changeVatNumber: {
        action: 'Aanpassen',
        message: 'Niet het juiste btw-nummer?',
      },
      header: {
        subtitle: 'We zien dat je een vennootschap hebt.',
        title: 'Hi, bestuurder van {{name}}',
      },
    },
    stepSuccess: {
      header: {
        subtitle: {
          eligible: 'Je hebt de finish bereikt, check je mailbox',
          ineligible: 'Gegevens goed ontvangen!',
        },
        title: 'Je account is aangemaakt',
      },
      linkAccountant: {
        errors: {
          generic: 'Er ging iets mis bij het koppelen van je boekhouder.',
        },
        form: {
          accountantEmailAddressField: {
            description:
              'Hier kan je het e-mailadres van je boekhouder invullen. Dan stellen we onszelf even kort voor, als die Creative Shelter nog niet kent.',
            label: 'Werk je samen met een boekhouder?',
          },
        },
        success: {
          message: 'Bedankt om ons de gegevens van je boekhouder te bezorgen. We gaan ermee aan de slag.',
          title: 'Goed ontvangen!',
        },
      },
      message: {
        eligible: 'Er is een e-mail verstuurd naar <bold>{{email}}</bold>. Bevestig je e-mailadres via de link om je account te activeren.',
        ineligible:
          'We dubbelchecken of je in aanmerking komt om te factureren via Creative Shelter.<break/>Dit venster mag je sluiten, we laten je zo snel mogelijk iets weten via e-mail.',
      },
    },
    stepVatNumber: {
      alert: {
        kboNotAvailable: {
          description: 'Door een storing bij de KBO kunnen we je btw-nummer nu niet controleren. Probeer je het later nog eens?',
          title: 'De KBO is even niet bereikbaar',
        },
      },
      form: {
        submitButton: 'Let’s go',
        vatNumberField: {
          description:
            'Heb je nog geen btw-nummer? <faqLink href="https://www.creativeshelter.be/knowledge-hub/kan-ik-mij-al-aansluiten-bij-creative-shelter-als-mijn-btw-nummer-nog-in-aanvraag-is">Lees hier</faqLink> wat je moet doen.',
          errors: {
            exists: 'Er is al een account met dit btw-nummer, dubbelcheck je even?',
            fallback: 'Er is een onverwachte fout opgetreden tijdens het valideren van je btw-nummer.',
            httpError:
              'Er ging iets mis bij het valideren van je btw-nummer. Neem contact op met <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het probleem zich blijft voordoen.',
            inactiveVatNumber:
              'Je btw-nummer is nog niet actief volgens de KBO. Registreren kan alleen met een actief btw-nummer, probeer je het later nog eens?',
            invalidVatNumber: 'Het opgegeven btw-nummer bestaat niet in de KBO. Dubbelcheck je even?',
            vatNumberChecksum: 'Het btw-nummer lijkt niet te kloppen. Check je even of er een foutje in staat?',
            vatNumberLength: 'Een btw-nummer bestaat uit 10 cijfers, waarvan het eerste cijfer 0 of 1 is.',
          },
          label: 'Btw-nummer',
        },
      },
      header: {
        subtitle: 'Maak gratis je Creative Shelter-account aan',
        title: 'Haal meer uit je auteursrechten',
      },
    },
  },
  resendVerificationEmail: {
    error:
      'Er ging iets mis bij het versturen van de verificatiemail. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
    send: 'Niets ontvangen? <button>Klik hier</button> om de e-mail opnieuw te versturen.',
    sent: 'We hebben een nieuwe verificatiemail verstuurd naar <bold>{{emailAddress}}</bold>. Nog steeds niets ontvangen? Probeer het opnieuw na {{seconds}} seconden.',
  },
  resetPasswordPage: {
    form: {
      submitButton: 'Stel je nieuwe wachtwoord in',
    },
    header: {
      subtitle: 'Kies een nieuw wachtwoord voor je account.',
      title: 'Nieuw wachtwoord instellen',
    },
  },
  sidebars: {
    checklist: {
      features: {
        first: 'Hou meer netto over dankzij je auteursrechten.',
        second: 'Factureer vlotjes via ons platform.',
        third: 'Krijg hulp van echte mensen en een freelance-community.',
        title: 'Het enige facturatieplatform dat auteursrechten regelt.',
      },
    },
    kiia: {
      eligibilityTest: {
        button: 'Doe de check',
        description: 'Ontdek met enkele simpele vragen of jij in aanmerking komt voor een vergoeding uit auteursrechten.',
        title: 'Kan jij auteursrechten factureren?',
      },
    },
  },
};
